import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';

const posDef: BnrGpPosModel[] = [];

// Gesetzliche Weiterbildungspflicht
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217001,
		group: 'gwp',
		posText: 'Weiterbildung IDD ',
		posDesc: 'Voraussetzung für die Bonifikation ist der Nachweis von 15 Weiterbildungsstunden im Geschäftsjahr',
		planKey: 'idd',
		einheit: Einheit.stck,
	}),
);

// Vertriebsschwerpunkte (außerhalb der Maximierung)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217005,
		group: 'vss',
		posText: 'Qualität in Beratung und Vertrieb',
		posDesc: 'GSL beurteilt die individuelle Zielerreichung anhand konkreter Kriterien',
		planKey: '',
		einheit: Einheit.quali,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217010,
		group: 'vss',
		posText: 'Firmen Kraft in Kleinflotten und Fuhrparkmodellen',
		posDesc: 'Langfristige Neustück',
		planKey: '',
		einheit: Einheit.stck,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'vss',
		posText: 'Sach Firmen',
		posDesc: 'Gekappte Meldejahresschadenquote der Geschäftsstelle',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217030,
		group: 'vss',
		posText: 'Unternehmensschutz',
		posDesc: 'Langfristige Neustück',
		planKey: 'privatundunternehemsschutz',
		einheit: Einheit.stck,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217035,
		group: 'vss',
		posText: 'Unfall Anschlussgeschäft',
		posDesc: 'Neu-/Mehrbeitrag ohne Anpassungen des Vertragspotentials gemäß Aktionsliste (Nr.25563)',
		planKey: '',
		einheit: Einheit.bew,
	}),
);

// Eingangshürde
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217041,
		group: 'eh',
		posText: 'Sach Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217042,
		group: 'eh',
		posText: 'Unfall und Sach Firmen',
		posDesc: 'Bewertung ohne Anpassung',
		planKey: 'unfallbew',
		einheit: Einheit.bew,
	}),
);

// Nach Eingangshürde (innerhalb einer Maximierung von 10.000 EUR)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217111,
		group: 'neh',
		posText: 'Sach Firmen ohne Kraft',
		posDesc: 'Bewertung',
		planKey: 'fsachokraftoanpbew',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217121,
		group: 'neh',
		posText: 'Kraft Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217131,
		group: 'neh',
		posText: 'Rechtsschutz Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217141,
		group: 'neh',
		posText: 'Sach Firmen ohne Kraft',
		posDesc: 'Bestandszuwachsbeitrag',
		planKey: 'fsachokraftoanpbew',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2217150,
		group: 'neh',
		posText: 'Unfall',
		posDesc: 'Bewertung ohne Anpassung',
		planKey: 'unfallbew',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'gpplus',
		posText: 'Unfall',
		posDesc: 'Bewertung ohne Anpassung: GS-Teamziel',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'gpplus',
		posText: '',
		posDesc: 'Unfall Bestandszuwachs Stück',
		planKey: '',
		einheit: Einheit.bew,
	}),
);

// Teamausschreibung
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'gpplus',
		posText: 'Teamausschreibung',
		posDesc: 'Platzierung in den Positionen im GSW der Vertriebsdirektion',
		planKey: '',
		einheit: Einheit.nogoal,
	}),
);
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Kundenzuwachs', planKey: '', einheit: Einheit.nogoal }));
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Cross-Selling', planKey: '', einheit: Einheit.nogoal }));
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Meine Allianz', planKey: '', einheit: Einheit.nogoal }));

export const LbsgPositionen = posDef;
